import axios from 'axios';
import { useQuery } from 'react-query';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

export const getIGESAvailable = async () => {
  try {
    const url = [`/periods/isIGESAvailable`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const getRGESMMAvailable = async () => {
  try {
    const url = [`/periods/isRGESMMAvailable`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const getRTENMMAvailable = async () => {
  try {
    const url = [`/periods/isRTENMMAvailable`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const getLoginGESAvailable = async () => {
  try {
    const url = [`/periods/isLoginGESAvailable`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const getMiembrosMesaAvailable = async (option) => {
  try {
    const url = [`/periods/isOptionMiembrosMesaAvailable/${option}`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const getFicalesMesaAvailable = async (option) => {
  try {
    const url = [`/periods/isOptionFiscalesMesaAvailable/${option}`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const getFicalesGeneralesAvailable = async (option) => {
  try {
    const url = [`/periods/isOptionFiscalesGeneralesAvailable/${option}`];

    const { data } = await axios.get(url.join('&'));

    return data;
  } catch (e) {
    return { data: {} };
  }
};

export const useIGESAvailable = () => {
  return useQuery(['iGesAvailable'], () =>
    getIGESAvailable(),
  );
};

export const useRGESMMAvailable = () => {
  return useQuery(['rGesMmAvailable'], () =>
    getRGESMMAvailable(),
  );
};

export const useRTENMMAvailable = () => {
  return useQuery(['rTenMmAvailable'], () =>
    getRTENMMAvailable(),
  );
};

export const useLoginGESAvailable = () => {
  return useQuery(['loginGESAvailable'], () =>
    getLoginGESAvailable(),
  );
};

export const useMiembrosMesaAvailable = (option) => {
  return useQuery([`miembrosMesaAvailable_${option}`], () =>
    getMiembrosMesaAvailable(option),
  );
};

export const useFiscalesMesaAvailable = (option) => {
  return useQuery([`fiscalesMesaAvailable_${option}`], () =>
    getFicalesMesaAvailable(option),
  );
};

export const useFiscalesGeneralesAvailable = (option) => {
  return useQuery([`fiscalesGeneralesAvailable_${option}`], () =>
    getFicalesGeneralesAvailable(option),
  );
};
